import React from 'react';

function PaginationArrowIcon({direction}) {
  return (direction === 'right'
    ? (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 10 22" enableBackground="new 0 0 10 22">
        <path fill="none" stroke="#9D9D9C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M2.19,2.12l5.36,8.03c0.34,0.51,0.34,1.17,0,1.69l-5.33,8.02"/>
      </svg>
    ) : (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 10 22" enableBackground="new 0 0 10 22">
        <path fill="none" stroke="#9D9D9C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M7.81,19.87l-5.36-8.03c-0.34-0.51-0.34-1.17,0-1.69l5.33-8.02"/>
      </svg>

    )
  );
}

export default PaginationArrowIcon;



// WEBPACK FOOTER //
// ./src/components/icons/PaginationArrowIcon.js